// index.js
import { default as uiReducer } from './reducers';
export { default as uiOperations } from './operations';
export { default as uiTypes } from './types';
export default uiReducer;